import { IGetRowsParams, GridApi } from 'ag-grid-community';
import { lastValueFrom } from 'rxjs';
import { AgGridDataSourceBase, AgGridDataSourceResult } from '../../../Compliance/AgGrid';
import { LeadDocketLogRepository } from '../leadDocketLog.repository';

export class LeadDocketLogListAgGridDataSource extends AgGridDataSourceBase<void> {
    constructor(
        readonly gridApi: GridApi,
        private readonly _leadDocketLogRepository: LeadDocketLogRepository
    ) {
        super(gridApi);
    }

    private readonly _propertyMap: Compliance.NameValuePair<Core.LeadDocketSummaryLogPropertyEnum>[] = [
        { name: 'leadDocketSummaryLogId', value: Core.LeadDocketSummaryLogPropertyEnum.LeadDocketSummaryLogId },
        { name: 'operationType', value: Core.LeadDocketSummaryLogPropertyEnum.OperationType },
        { name: 'litigationReferralId', value: Core.LeadDocketSummaryLogPropertyEnum.LitigationReferralId },
        { name: 'matterId', value: Core.LeadDocketSummaryLogPropertyEnum.MatterId },
        { name: 'siteId', value: Core.LeadDocketSummaryLogPropertyEnum.SiteId },
        { name: 'startTime', value: Core.LeadDocketSummaryLogPropertyEnum.StartTime },
        { name: 'endTime', value: Core.LeadDocketSummaryLogPropertyEnum.EndTime },
        { name: 'requestPayloadJson', value: Core.LeadDocketSummaryLogPropertyEnum.RequestPayloadJson },
        { name: 'responsePayloadJson', value: Core.LeadDocketSummaryLogPropertyEnum.ResponsePayloadJson }
    ];

    protected canGetRows(): boolean {
        return true;
    }

    protected async getRowsInternal(params: IGetRowsParams): Promise<AgGridDataSourceResult> {
        const searchParams: Core.LeadDocketSummaryLogSearchModel = {
            pagination: {
                skip: params.startRow,
                take: params.endRow - params.startRow
            },
            columnFilters: this.getColumnFilters(this._propertyMap),
            sortColumns: this.getSortColumns(this._propertyMap)
        };

        const result = await lastValueFrom(this._leadDocketLogRepository.getList(searchParams));

        return {
            rows: result.data,
            totalRows: result.totalRows
        } as AgGridDataSourceResult;
    }
}
